<template>
  <div class="coursePage" style="margin-top: 40px;">
    <div class="courseBox" v-for="list,idx in typeList" :key="idx">
      <p class="courseTitle">
        {{list.name}} |
        <span class="courseTitleLevel" @click="openMoreFn">更多</span>
      </p>
      <ul class="classBox">
        <li class="classList" :class="[classActive == item ? 'classListActive' :'']" v-for="item,index in list.searchList" :key="index" @click="searchFn(list,item,idx)">{{ item.text }}</li>
      </ul>
      <a-row :gutter="_isMobile() ? [0,20]:[20,20]" v-if="list.list.length > 0">
        <a-col :xs="24" :sm="24" :md="6" v-for="item,index in list.list" :key="index">
          <div class="courseList" @click="openDetailsFn(item)">
            <img :src="item.courseCover_url" class="courseImage" alt="">
            <p class="p1">{{ item.courseName || '-'}}</p>
            <p class="p2">{{ item.teacherName || '-' }}</p>
            <div class="courseFooter">
              <div class="courserType" :style="{'background':backgroundList[Math.floor(Math.random() * backgroundList.length)]}" v-if="item.courseLevel_dictText">{{ item.courseLevel_dictText }}</div>
              <div v-else></div>
              <div class="courserOverview">
                <span>{{ item.courseCount || 0 }}课时  </span>
                <span> <i>|</i> 学习人数:{{ item.viewNum || '-' }}   </span>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-empty v-else description="暂无课程" style="margin: 60px auto;" />
    </div>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from "@/api/manage";
import {ajaxGetDictItems} from '@/api/api'
export default {
  mixins: [mixinDevice],
  name: "",
  components: {},
  data() {
    return {
      backgroundList:['#AE5DA1','#EC6941','#32B16C','#556FB5'],
      classActive:1,
      courseList:[],
      typeList:[
        {
          name:'主题分类',
          code:'course_type',
          value:'courseType',
          searchList:[{text:'全部',value:''}],
          list:[],
        },{
          name:'使用场景分类',
          code:'course_type2',
          value:'courseType2',
          searchList:[{text:'全部',value:''}],
          list:[]
        }
      ],
      queryForm:{}
    };
  },
  created() {
    for(var i=0;i<this.typeList.length;i++){
      this.init(this.typeList[i],i)
    }
  },
  mounted() {},
  methods: {
    init(obj,i){
      ajaxGetDictItems(obj.code,null).then(res=>{
        if(res.success){
          this.typeList[i].searchList = this.typeList[i].searchList.concat(res.result)
        }
      })
      this.getData(i)
    },
    getData(i){
      getAction('/teaching/teachingCourse/showCourse',this.queryForm).then(res=>{
        if(res.code == 200){
          this.typeList[i].list =  res.result.records
        }
      })
    },
    searchFn(list,item,index){
      this.queryForm = []
      this.queryForm[list.value] = item.value
      this.getData(index)
    },
    openMoreFn(){
      this.$router.push({path:'/list'})
    },
    openDetailsFn(item){
      this.$router.push({path:'/detail',query:{id:item.id}})
    }
  },
};
</script>
<style lang='scss' scoped>
.coursePage {
  width: 100%;
  p{
    margin: 0;
  }
  ul,li{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .courseList:hover {
    box-shadow: 2px 2px 6px 0px rgba(91, 106, 140, 0.36);
    background: #fff;
    border-radius: 10px;
  }
  .courseBox {
    width: 100%;
    margin-bottom: 80px;
    .courseList{
      width: 100%;
      height: auto;
      cursor: pointer;
      .courseFooter{
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        .courserType{
           height: 24px;
           width: auto;
           border-radius: 5px;
           background: #AE5DA1;
           color: #fff;
           line-height: 24px;
           font-size: 16px;
           padding: 0 6px;
        }
        .courserOverview{
          font-size: 16px;
          color: #666666;
        }
      }
      .courseImage{
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 10px;
      }
      .p1{
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        padding: 14px 10px 6px 10px;
      }
      .p1:hover{
        color: #184DD5;
      }
      .p2{
        font-size: 16px;
        color: #666666;
        padding: 0 10px;
      }
    }
    .courseTitle{
      font-size: 22px;
      font-weight: 600;
      color: #333;
      text-align: left;
      .courseTitleLevel{
        font-size: 16px;
        cursor: pointer;
      }
    }
    .classBox{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      margin: 20px 0 16px 0;
      .classList{
        height: 30px;
        width: auto;
        padding: 0 10px;
        font-size: 16px;
        color: #999;
        line-height: 30px;
        border: 1px solid #999;
        border-radius: 15px;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .classList:hover{
        background: #184DD5;
        color: #fff;
        border-color: #184DD5;
      }
      .classListActive{
        background: #184DD5 !important;
        color: #fff !important;
        border-color: #184DD5 !important;
      }
    }
    
  }
}
</style>
